export default __webpack_public_path__ + "static/media/icon-sun.cb7a2aac.svg";